import { Tooltip } from "@/components/General/Tooltip/tooltip.component";
import { CartItemModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import { Config } from "@/utils/config.utils";
import { getProductConfigurationPreview } from "@/utils/productConfiguration";
import { ProductConfiguration } from "@/utils/productConfiguration/productConfiguration.types";

type CartItemInfoTitleProps = {
    isWarrantyDeposit: boolean;
    isConfigurableProduct: boolean;
    cartItem: CartItemModel;
    warrantyDepositTooltipInfo: string;
    productConfiguration?: ProductConfiguration;
};

const CartItemInfoTitle = ({
    isConfigurableProduct,
    isWarrantyDeposit,
    cartItem,
    warrantyDepositTooltipInfo,
    productConfiguration
}: CartItemInfoTitleProps) => {
    if (isWarrantyDeposit) {
        return (
            <>
                {cartItem.title}
                {warrantyDepositTooltipInfo && (
                    <Tooltip innerHTML={warrantyDepositTooltipInfo} />
                )}
            </>
        );
    }

    if (isConfigurableProduct) {
        return (
            <span className="h3 text-secondary-link-color">
                {cartItem.title}
            </span>
        );
    }

    const getProductUrl = (url?: string | null) => {
        if (cartItem?.giftCardArticle && cartItem?.id) {
            return `${Config.pages.giftcard}?cartid=${cartItem.id}`;
        }

        if (Object.keys(cartItem.configuration || {}).length && cartItem?.id) {
            return `${cartItem.url}?cartid=${cartItem.id}`;
        }

        return url;
    };

    const productUrl = getProductUrl(cartItem.url);
    return (
        <>
            {productUrl && (
                <a
                    href={productUrl}
                    className="h3"
                >
                    {cartItem.title}{" "}
                    {getProductConfigurationPreview(
                        cartItem.configuration,
                        productConfiguration
                    )}
                </a>
            )}
        </>
    );
};

export { CartItemInfoTitle };
